/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsListJobEvents } from "../../funcs/computeJobsListJobEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListJobEventsRequest$inboundSchema,
};

export const tool$computeJobsListJobEvents: ToolDefinition<typeof args> = {
  name: "compute-jobs-list-job-events",
  description: `List job events`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsListJobEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
